import { styled, Box } from "@mui/material";

export const StyledGameCardNote = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;

  ${({ theme: { wsc } }) => `
    padding: ${wsc.spacing[3]};
    border-radius: ${wsc.radius.m};
    background-color: ${wsc.palette.neutral[700]};
    border: 1px solid ${wsc.palette.neutral[500]};
    box-shadow: ${wsc.shadow.s2};
    margin: ${wsc.spacing[2]}
      ${wsc.spacing[1]} 0
      ${wsc.spacing[1]};
  `}
`;

export const StyledGameCardNoteText = styled("span")`
  ${({ theme: { wsc } }) => wsc.typography.body1};

  flex: 1;
  text-align: center;
  color: ${({ theme: { wsc } }) => wsc.palette.neutral[100]};
`;

export const StyledGameCardNoteCrossIconWrapper = styled(Box)`
  margin-left: auto;
  cursor: pointer;
  color: ${({ theme: { wsc } }) => wsc.palette.neutral[100]};
`;
